import { Restriction as BaseRestriction } from "./Restriction";
export class Base {
    description;
    condition;
    get definition() {
        return {
            name: this.name,
            class: this.class,
            ...(this.description ? { description: this.description } : {}),
            ...(this.condition ? { condition: this.condition } : {}),
        };
    }
    constructor(description, condition) {
        this.description = description;
        this.condition = condition;
    }
    get(value, fallback) {
        return this.is(value) ? value : fallback;
    }
    prune(value) {
        return this.is(value) ? value : undefined;
    }
    flawed(value) {
        return (!this.is(value) && {
            name: this.name,
            ...(this.description ? { description: this.description } : {}),
            ...(this.condition && this.condition.length > 0 ? { condition: this.condition } : {}),
        });
    }
    restrict(...restriction) {
        const previous = this.is.bind(this);
        return this.modify({
            is: (value) => previous(value) && restriction[0](value),
            condition: [...(this.condition ?? []), restriction[1]],
            name: restriction[2] ?? this.name,
            ...(restriction[3] ? { description: restriction[3] } : {}),
        });
    }
    rename(name) {
        return this.modify({ name });
    }
    describe(description) {
        return this.modify({ description });
    }
    optional(name) {
        return Base.isly.optional(this, name);
    }
    readonly(name) {
        return Base.isly.readonly(this, name);
    }
    array(...restriction) {
        return Base.isly.array(this, ...restriction);
    }
    inverse(name) {
        return Base.isly.inverse(this, name);
    }
    or(type) {
        return Base.isly.union(this, type);
    }
    and(type) {
        return Base.isly.intersection(this, type);
    }
    toString() {
        return JSON.stringify(this.definition);
    }
    toJSON() {
        return this.definition;
    }
    modify(changes) {
        const result = { ...this, name: changes?.name ?? this.name };
        Object.defineProperty(result, "definition", {
            get: getPropertyDescriptor(changes, "definition")?.get ??
                getPropertyDescriptor(this, "definition")?.get ??
                (() => {
                    throw Error("Not Implemented");
                }),
            enumerable: true,
            configurable: false,
        });
        return Object.assign(result, {
            ...changes,
            is: changes?.is ?? this.is,
            get: changes?.get ?? this.get,
            prune: changes?.prune ?? this.prune,
            flawed: changes?.flawed ?? this.flawed,
            restrict: changes?.restrict ?? this.restrict,
            rename: changes?.rename ?? this.rename,
            describe: changes?.describe ?? this.describe,
            optional: changes?.optional ?? this.optional,
            readonly: changes?.readonly ?? this.readonly,
            array: changes?.array ?? this.array,
            inverse: changes?.inverse ?? this.inverse,
            and: changes?.and ?? this.and,
            or: changes?.or ?? this.or,
            toString: changes?.toString ?? this.toString,
            toJSON: changes?.toJSON ?? this.toJSON,
            modify: changes?.modify ?? this.modify,
            bind: changes?.bind ?? this.bind,
        });
    }
    bind() {
        return {
            ...this,
            type: this,
            is: this.is.bind(this),
            get: this.get.bind(this),
            prune: this.prune.bind(this),
            flawed: this.flawed.bind(this),
            restrict: this.restrict.bind(this),
            rename: this.rename.bind(this),
            describe: this.describe.bind(this),
            optional: this.optional.bind(this),
            readonly: this.readonly.bind(this),
            array: this.array.bind(this),
            inverse: this.inverse.bind(this),
            and: this.and.bind(this),
            or: this.or.bind(this),
            toString: this.toString.bind(this),
            toJSON: this.toJSON.bind(this),
            modify: this.modify.bind(this),
        };
    }
    static isly;
}
(function (Base) {
    Base.Restriction = BaseRestriction;
})(Base || (Base = {}));
function getPropertyDescriptor(object, property) {
    let result = object;
    while (result && !Object.prototype.hasOwnProperty.call(result, property))
        result = Object.getPrototypeOf(result);
    return result ? Object.getOwnPropertyDescriptor(result, property) : undefined;
}
//# sourceMappingURL=index.js.map